<template>
    <div class="alert-ctn" v-show="isVisible">
      <transition name="fade" mode="out-in">
        <b-alert v-model="isVisible" :variant="variant" class="alert">
          <slot></slot>
        </b-alert>
      </transition>
    </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'base-alert',
  components: {
    'b-alert': BAlert
  },
  data () {
      return {
        dismissCountDown: 0
      }
  },
  props: {
    value: {
			type: Boolean,
			required: false,
			default: true
		},
    variant: {
      type: String,
      required: true,
      default: null
    },
    time: {
      type: Number,
      required: false,
      default: 6
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.value ? this.time : 0
      },
      set (val) {
        this.$emit('input', val > 0)
      }
    }
  }
}
</script>

<style lang="scss">
  .alert-dismissible .close{
    top: -12px !important;
  }

  .alert-danger {
    border-color: transparent;
  }

  .alert-info {
    background-color: $blue;
    color: $secondary !important;
  }

  .alert-ctn {
    @include desktop {
      padding: 0px 30rem;
    }

    @include tablets {
      padding: 0 10rem;
    }

    @include mobile {
      padding: 0 1rem;
    }
    
    margin: auto; 
    text-align: center;
    position: absolute;
    width: 100%;

    .alert {
      color: $black;
      z-index: 1000000;
      position: fixed;
      left: 0;
      right: 0;
      margin: auto;
      width: 50%;
      top: 1rem;
      overflow: hidden;
      z-index: 9999;
      white-space: normal;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/ui/BaseAlert.vue